import React from 'react';
import styled from 'styled-components';
import Item, { Section, Content, Button } from './item';
import { offsets, fontSizes, colors } from '../../../styles';
import { addItem } from '../../../helpers/basket';

const Price = styled(Section)`
  font-size: ${fontSizes.sm};
  color: ${colors.black};
`;

const RollItem = ({ id, name, consistsOf, count, weight, price, pictureId }) => (
  <Item
    imgUrl={require(`../../../images/menu-pics/${pictureId}.png`)}
    imgAlt={`pizza-${id}`}
    name={name}
    id={id}
  >
    <Section>
      <b>Состав:</b>&nbsp;
      <span dangerouslySetInnerHTML={{__html:consistsOf}}/>
    </Section>
    {
      count && (
        <Section>
          <b>Количество</b>: {count} шт
        </Section>
      )
    }
    <Section>
      <b>Вес</b>: {weight} гр
    </Section>
    <Price>
      <b>Цена</b>: {price} р
    </Price>
  </Item>
);

export default RollItem;
